/**
 * account 个人中心（center/settings）模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  // center/Index.vue
  '海纳百川，有容乃大': 'The sea admits hundreds of rivers for its capacity to hold',
  '交互专家': 'Interaction Expert',
  '蚂蚁金服－某某某事业群－某某平台部－某某技术部－UED': 'Ant Financial – Business Group – Platform Dept – Tech Dept – UED',
  '浙江省': 'Zhejiang',
  '杭州市': 'Hangzhou',
  '标签': 'Label',
  '团队': 'Teams',
  '很有想法的': 'Full of Ideas',
  '专注设计': 'Design Focused',
  '辣~': 'Spicy~',
  '大长腿': 'Long Legs',
  '川妹子': 'Sichuan Girl',
  '海纳百川': 'All-embracing',
  '文章(8)': 'Articles (8)',
  '应用(8)': 'Apps (8)',
  '项目(8)': 'Projects (8)',
  // center/page/App.vue
  '活跃用户': 'Active Users',
  '万': '10K',
  '新增用户': 'New Users',
  // settings/BaseSetting.vue
  '昵称': 'Nickname',
  '给自己起个名字': 'Give yourself a name',
  '电子邮件': 'Email',
  '加密方式': 'Encryption',
  '连接密码': 'Connection Password',
  '登录密码': 'Login Password',
  '提交': 'Submit',
  '保存': 'Save',
  // settings/Security.vue
  '账户密码': 'Account Password',
  '当前密码强度': 'Current password strength',
  '密保手机': 'Security Mobile',
  '已绑定手机': 'Bound Mobile',
  '修改': 'Edit',
  '密保问题': 'Security Question',
  '未设置密保问题，密保问题可有效保护账户安全': 'No security question set. A security question can effectively protect your account.',
  '设置': 'Settings',
  '备用邮箱': 'Backup Email',
  '已绑定邮箱': 'Bound Email',
  'MFA 设备': 'MFA Device',
  '未绑定 MFA 设备，绑定后，可以进行二次确认': 'No MFA device bound. After binding, secondary confirmation is available.',
  '绑定': 'Bind',
  // settings/Custom.vue
  '暗色': 'Dark',
  '白色': 'Light',
  '风格配色': 'Style & Theme',
  '整体风格配色设置': 'Overall style and color settings',
  '主题色': 'Theme Color',
  '页面风格配色：': 'Page style color: ',
  // settings/Index.vue
  '基本设置': 'Basic Settings',
  '安全设置': 'Security Settings',
  '个性化': 'Personalization',
  '账户绑定': 'Account Binding',
  '新消息通知': 'New Message Notification',
  '账号绑定': 'Account Binding',
  // settings/AvatarModal.vue
  '修改头像': 'Change Avatar',
  '上传头像成功': 'Avatar uploaded successfully',
  // settings/selectQuickMenu.vue
  '可跳转的路由': 'Navigable Routes',
  '确定放弃编辑？': 'Are you sure to discard the changes?',
  '仅保存': 'Save Only',
  '保存并关闭': 'Save and Close',
  '添加快速导航': 'Add Quick Navigation',
  // settings/Workplace.vue
  '待办任务': 'To-do Tasks',
  '我的待办': 'My To-do',
  '已办任务': 'Done Tasks',
  '我的已办': 'My Done',
  '公告面板': 'Announcement Panel',
  '行政公告': 'Administrative Announcement',
  '红头文件': 'Red-Head Document',
  '新闻资讯': 'News & Information',
  '赏罚通报': 'Reward & Punishment Report',
  '市场观察': 'Market Watch',
  '便捷导航': 'Quick Navigation',
  '添加': 'Add',
  '工程报装': 'Engineering Installation',
  '申请面板': 'Application Panel',
  '任务编号': 'Task No.',
  '流程名称': 'Process Name',
  '流程发起人': 'Process Initiator',
  '接收时间': 'Received At',
  '审批时间': 'Approval Time',
  '耗时': 'Duration',
}
